import React from 'react'
import styled from 'styled-components'

import ExploreLink from 'components/navigation/ExploreLink'

const Name = styled.p`
  text-align: center;
`
const StyledExploreLink = styled(ExploreLink)`
  border-radius: 5px;
  padding: 1rem 0.67rem;
  background-color: ${({ theme }) => theme.background};
  border: 1px solid ${({ theme }) => theme.special2};
  cursor: pointer;
  color: ${({ theme }) => theme.special2};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${({ theme }) => theme.callToAction};
    border: 1px solid ${({ theme }) => theme.callToAction};
    color: ${({ theme }) => theme.special3};
  }
`

interface TopicProps {
  name: string
}
const Topic = ({ name }: TopicProps) => {
  return (
    <StyledExploreLink fields={{ Topic: [name] }}>
      <Name>{name}</Name>
    </StyledExploreLink>
  )
}

export default Topic
